import React, { FC } from 'react'
import { Box, Divider, Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { Modal } from '../../../../../components/Modal'
import { clientTypesLoading, getClientTypeDetailsData } from '../../../../../store/selectors'
import { Loader } from '../../../../../components/Loader'

interface ClientTypeCreateModalProps {
  isOpen: boolean
  modalClose: () => void
}

export const ClientTypeViewModal: FC<ClientTypeCreateModalProps> = ({ isOpen, modalClose }) => {
  const loading = useSelector(clientTypesLoading)
  const data = useSelector(getClientTypeDetailsData)

  if (loading) return <Loader />
  return (
    <Modal title={'Client Type Details'} isOpen={isOpen} modalClose={modalClose} submitButtonProps={{ visible: false }}>
      {data ? (
        <Grid container spacing={2} display={'flex'} justifyContent={'space-between'} minHeight={80}>
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              Name:
            </Typography>
            <Typography>{data.name}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" component="div">
              Created:
            </Typography>
            <Typography>{new Date(data.createdAt).toLocaleString()}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" component="div">
              Updated:
            </Typography>
            <Typography>{new Date(data.updatedAt).toLocaleString()}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6">Assets:</Typography>
            {data.assets.length === 0 ? (
              <Typography>No assets available</Typography>
            ) : (
              <Box component="ul" sx={{ pl: 2 }}>
                {data.assets.map((asset) => (
                  <li key={asset.id}>
                    <Typography>
                      <strong>{asset.label}</strong> – Last synced: {new Date(asset.updatedAt).toLocaleString()}
                    </Typography>
                  </li>
                ))}
              </Box>
            )}
          </Grid>
        </Grid>
      ) : (
        <Typography>No data</Typography>
      )}
    </Modal>
  )
}
